const TOKEN_KEY = 'userData';

export const saveTokens = (accessToken, refreshToken, userData) => {
  const data = {
    accessToken,
    refreshToken,
    userData,
    timestamp: new Date().getTime()
  };
  localStorage.setItem(TOKEN_KEY, JSON.stringify(data));
};

export const getTokens = () => {
  const data = localStorage.getItem(TOKEN_KEY);
  if (!data) return null;
  
  try {
    const parsedData = JSON.parse(data);
    return parsedData;
  } catch (error) {
    console.error('Error parsing token data:', error);
    return null;
  }
};

export const removeTokens = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isAuthenticated = () => {
  const tokens = getTokens();
  return !!tokens?.accessToken;
};

export const getAccessToken = () => {
  const tokens = getTokens();
  return tokens?.accessToken;
};

export const getRefreshToken = () => {
  const tokens = getTokens();
  return tokens?.refreshToken;
};

export const getUserData = () => {
  const tokens = getTokens();
  return tokens?.userData;
}; 